import { BuilderContent } from '@builder.io/sdk';
import { DrawerMegaMenuItem } from '@/types/drawerMegaMenuItem';

export interface MenuItem {
	id: string | undefined;
	title: string;
	internalLink: string | undefined;
	externalLink: string | undefined;
	children?: MenuItem[];
}

export const mapFooterMenus = (jsonData: BuilderContent[]): MenuItem[] => {
	const sortedJsonData = jsonData.sort((a, b) => {
		const orderA = a.data?.order ?? 0;
		const orderB = b.data?.order ?? 0;
		return orderA - orderB;
	});

	return sortedJsonData.map((item) => ({
		id: item.id,
		title: item.data?.title,
		internalLink: item.data?.internallink?.value?.data?.url,
		externalLink: item.data?.externallink,
		children:
			item.data?.items?.map((subItem) => ({
				id: subItem.id,
				title: subItem?.title,
				internalLink: subItem?.internallink?.value?.data?.url,
				externalLink: subItem?.externallink,
			})) ?? [],
	}));
};

export const mapCmsMegaMenuMenus = (jsonData: BuilderContent[]): DrawerMegaMenuItem[] => {
	// mapCmsMegaMenuMenus is used to map the CMS mega menu items to fix the drawer menu level structure
	return jsonData.map((item) => ({
		id: item.id,
		name: item.data?.title,
		externalLink: item.data?.externalLink,
		internalLink: item.data?.internalLink?.value?.data?.path,
		children:
			item.data?.firstMenuItems?.map((level2) => ({
				name: level2.title,
				externalLink: level2?.externalLink && level2.externalLink.length > 0 ? level2.externalLink : undefined,
				internalLink: level2?.internalLink?.value?.data?.path,
				children:
					level2.secondMenuItems?.map((level3) => ({
						name: level3.title,
						externalLink: level3?.externalLink,
						internalLink: level3.internalLink?.value?.data?.path,
						children:
							level3.thirdMenuItems?.map((level4) => ({
								name: level4.title,
								externalLink: level4?.externalLink,
								internalLink: level4.internalLink?.value?.data?.path,
							})) ?? [],
					})) ?? [],
			})) ?? [],
	}));
};
